import { render, Suspense } from "@wordpress/element";
import withAppProviders from "withAppProviders";
import Block from "./Block";

const LoginFrontend = ({ attributes }) => {
	return <Block attributes={attributes} />;
};

const Login = withAppProviders(LoginFrontend)();

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-vino-register");
	if (element) {
		render(
			<Suspense fallback={<div className="wp-block-placeholder" />}>
				<Login />
			</Suspense>,
			element
		);
	}
});
